import { connect } from 'react-redux';

import {
  fetchPullRequestAuthors,
  fetchPullRequestAuthor,
  clearFilteredAuthors,
  updatePreloadedAuthor,
} from 'src/redux/pull-request-list/actions';
import {
  getPullRequestAuthorsSlice,
  getPullRequestAuthorOptions,
  getPullRequestPreloadedAuthorOption,
  getPullRequestPreloadedAuthorSlice,
} from 'src/redux/pull-request-list/selectors';
import { BucketState } from 'src/types/state';

import AuthorSelector, {
  OwnProps as AuthorSelectorProps,
} from '../components/author-selector';

const mapStateToProps = (state: BucketState, ownProps: AuthorSelectorProps) => {
  const { isLoading: isLoadingAuthors, isError } =
    getPullRequestAuthorsSlice(state);
  const preloadedOption = getPullRequestPreloadedAuthorOption(ownProps.uuid)(
    state
  );
  const options = getPullRequestAuthorOptions(state);
  const { isLoading: isLoadingAuthor } =
    getPullRequestPreloadedAuthorSlice(state);

  return {
    preloadedOption,
    options,
    isLoadingAuthors,
    isLoadingAuthor,
    isError,
  };
};

const mapDispatchToProps = {
  fetchPullRequestAuthors,
  fetchPullRequestAuthor,
  clearFilteredAuthors,
  updatePreloadedAuthor,
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthorSelector);
